export default __webpack_public_path__ + "static/media/Grimherald Jerkin.d9a90374.jpg";